// Chandrika Seva Mission — the organisation's logo.
//
// This is the real asset (the circular badge already used on the Mission's own
// channel sites), not a redrawing. The other candidate was the filed device
// mark from the trademark pack (application 7858157), but the only copy of it
// is a glossy mockup JPEG with the emblem baked onto a grey gradient under a
// heavy glow — the glow cannot be keyed out cleanly, and a hand-drawn SVG
// rendition of a registered mark is worse than using the mark itself.
//
// Bundled through Vite rather than hot-linked, so it is fingerprinted, cached
// and never depends on another site staying up.
import type { CSSProperties } from "react";

import logoUrl from "../assets/chandrika-seva-mission.webp";

interface Props {
  size?: number;
  className?: string;
  style?: CSSProperties;
  /** Decorative beside the wordmark; give it a label when it stands alone. */
  alt?: string;
}

export function CsmLogo({ size = 30, className, style, alt }: Props) {
  return (
    <img
      src={logoUrl}
      width={size}
      height={size}
      alt={alt ?? ""}
      aria-hidden={alt ? undefined : true}
      className={className}
      draggable={false}
      style={{
        display: "block", flexShrink: 0, borderRadius: "50%",
        // The badge is a circular emblem on a white ground; a hairline ring
        // keeps it from dissolving into a light surface without adding chrome.
        boxShadow: "0 0 0 1px color-mix(in srgb, var(--accent-gold) 45%, transparent)",
        ...style,
      }}
    />
  );
}

export { logoUrl as csmLogoUrl };
